import * as types from "../actions/actionTypes";

export default function ivrListReducer(
  state = {
    trips: {},
    errors: {},
  },
  action
) {
  switch (action.type) {
    case types.LOAD_IVRS_SUCCESS:
      return { ...state, trips: action.data, errors: {} };
    case types.LOAD_IVRS_ERROR:
      return { ...state, trips: {}, errors: action.error };
    default:
      return { ...state };
  }
}
